import { get, set } from "./_cookie";

const cookiebar = document.querySelector('.js-cookiebar');

if (cookiebar) {
    const hasAcceptedCookies = get('hasAcceptedCookies') || null;

    if (hasAcceptedCookies === null) {
        cookiebar.setAttribute('data-visible', '');
    }

    [...cookiebar.querySelectorAll('.js-cookiebar-btn')].map(btn => btn.addEventListener('click', () => {
        set('hasAcceptedCookies', btn.dataset.type, 365);
        cookiebar.removeAttribute('data-visible');
    }))
}
